import { createApiQueryHook, IApiQueryFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { IPageTranslationList, IPageResource } from "../types";

export interface IPageTranslationsQueryParameters {
    page?: RelationalValue<IPageResource>;
}

export type IPageTranslationsQueryResult = IPageTranslationList;

export const pageTranslationsQuery: IApiQueryFunction<IPageTranslationsQueryParameters> = ({ page }) => {
    if (!page) {
        return;
    }

    return {
        method: "GET",
        url: `/pages/${mapRelationalValue(page)}/translations`,
    };
};

export const usePageTranslationsQuery = createApiQueryHook<
    IPageTranslationsQueryParameters,
    IPageTranslationsQueryResult
>(pageTranslationsQuery);
